
import request from './request'
let service = request[0], service1 = request[1], service2 = request[2], service3 = request[3], service4 = request[4], service5 = request[5];
import req from './http'

export default {
  NewCode(params){
  	return req.get(service4, '/Plugin_Byte?ClassName=Plugin_Common_GraphicVerificationCode.NewCode&type=2&width=60&height=25&fontColor=%23ffffff&backgroundColor=%23555555',params)
  },
  
  verificationCode(params){
  	return req.get(service4, '/Cache?Name=_Plugin_Common_GraphicVerificationCode',params)
  },
  errorNum(params){
  	return req.get(service5, '/Cache?Name=errorNum',params)
  },
  RemoveCache(params){
  	return req.get(service5, '/RemoveCache?Name=errorNum',params)
  },
  ClearTimeoutCache(params){
  	return req.get(service5, '/ClearTimeoutCache?Name=errorNum',params)
  },
  SMSCode(params){
  	return req.get(service5, '/Cache?Name=SMSCode',params)
  },
  UpdateActivityType (params) {
    return req.get(service, '/ExSql?SqlCmdName=ShopWebApp\\UpdateActivityType_1_0_1&DBC=w_m', params)
  },

  GetSocialRecruitmentList (params) {
    return req.get(service, '/QueryData?SqlCmdName=ShopWebApp\\GetActivityTypeList_1_0_1&DBC=r_m', params)
  },
  DeleteActivityType (params) {
    return req.get(service, '/ExSql?SqlCmdName=ShopWebApp\\DeleteActivityType_1_0_1&DBC=w_m', params)
  },
  GetActivityBannerInfo (params) {
    return req.get(service, '/QueryData?SqlCmdName=ShopWebApp\\GetActivityBannerInfo_1_0_1&DBC=w_m', params)
  },
  //文件上传
  upLoad (appendUrl, params) {
    return req.post(service, '/UpLoadFile?FileName=' + appendUrl, params)
  },

	OutputCsv(url,params){
		return req.post(service4,'/OutputCsv?SqlCmdName='+url,params)
	},
  //文件上传
  upLoad (appendUrl, params) {
    return req.post(service2, `/UpLoadFile?FileName=` + appendUrl, params)
  },
  //文件删除
  deleteFn (appendUrl, params) {
    return req.post(service2,`/DeleteFile`+ appendUrl, params)
  },
  UpdatePreferentialSetting (params) {
    return req.get(service, '/ExSql?SqlCmdName=ShopWebApp\\UpdatePreferentialSetting_1_0_1&DBC=w_m', params)
  },
  GetShopOrderNum (params) {
    return req.get(service, '/QueryData?SqlCmdName=ShopWebApp\\GetShopOrderNum_1_0_2&DBC=r_b1∑r_b2', params)
  },
  UpdateHelpCenterInfo (params) {
    return req.post(service, '/ExSql?SqlCmdName=ShopWebApp\\UpdateHelpCenterInfo_1_0_1&DBC=w_m', params)
  },

  GetHelpCenterList (params) {
    console.log(params, 4000)
    return req.get(service, '/QueryData?SqlCmdName=ShopWebApp\\GetHelpCenterList_1_0_1&DBC=r_m', params)
  },
  // UpdateActivityType (params) {
  //   return req.get('/ExSql?SqlCmdName=ShopWebApp\\UpdateActivityType_1_0_1&DBC=w_m', params)
  // },

  GetCommodityTypeList (params) {
    return req.get(service,'/QueryData?SqlCmdName=ShopWebApp\\GetCommodityTypeList_1_0_1&DBC=r_m', params)
  },
  AuctionOpenOrNot (params) {
    return req.get(service1, `/Cache?Name=AuctionOpenOrNot&Key=AuctionOpenOrNot`, params)
  },

  // GetSocialRecruitmentList (params) {
  //   return req.get('/QueryData?SqlCmdName=ShopWebApp\\GetActivityTypeList_1_0_1&DBC=w_m', params)
  // },
  returnGuid () {
    return req.returnGuid(service2, '')
  },

  QueryDataFn (url, params) {
    return req.post(service, '/QueryData?SqlCmdName=' + url, params)
  },
  QueryDataFn1 (url, params) {
    return req.post(service4, '/QueryData?SqlCmdName=' + url, params)
  },
 
  PluginFn (url, params) {
    return req.get(service2, '/Plugin_Text?ClassName=' + url, params)
  },
  ExSqlFn (url, params) {
    return req.post(service, '/ExSql?SqlCmdName=' + url, params)
  },
  exsqlDistributedUrl(url, params){
    return req.post(service2, '/ExSql_Distributed?TransactionName=' + url, params)

  },
	//文件删除
	deleteFn (appendUrl, params) {
	  return req.post(service2,`/DeleteFile`+ appendUrl, params)
	},
	UpLoadFileFn(url,params,config){
		return req.post(service2,'/UpLoadFile?'+url,params,config)
	},
  // ExSql_Distributed (params) {//合并
  //   return req.post('/ExSql_Distributed?TransactionName=' + params.TransactionName, params)
  // },
}


// WEBPACK FOOTER //
// ./src/utils/api.js